import netsuiteApi from "../api/netsuiteApi";
import createCache from "./localStorageCache";

const poNumberCache = createCache("poNumbers");

const findPoNumbers = async (poIds) => {
  const cached = {};
  const missing = [];

  for (const poId of poIds) {
    const hit = poNumberCache.get(poId);
    if (hit) {
      cached[poId] = hit;
    } else {
      missing.push(poId);
    }
  }

  if (missing.length === 0) return cached;

  const fetched = await fetchPoNumbers(missing);

  for (const [poId, poNumber] of Object.entries(fetched)) {
    poNumberCache.set(poId, poNumber);
  }

  return { ...cached, ...fetched };
};

const fetchPoNumbers = async (poIds) => {
  return netsuiteApi.fetchPoNumbers(poIds).then((result) => {
    console.log('TEEEST', result.data)
    if (result.data.success) {
      return result.data.data;
    }
    alert("Error fetching PO numbers");
    return {};
  });
};

export default findPoNumbers;